module.exports = __webpack_public_path__ + "static/media/FE2100-51E_02.b1d01c6c.png";